var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.687,
    height: 59.688,
    viewBox: "0 0 59.687 59.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5558ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c0ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#addcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaf6ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.808 10.804)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(0.038 0.037)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.088,38.075l6.993-6.992a1.769,1.769,0,0,0,.514-1.239V19.352a1.749,1.749,0,1,0-3.5,0V29.12L21.616,35.6a1.748,1.748,0,1,0,2.473,2.473ZM29.847,0A29.961,29.961,0,0,0,0,29.844a1.851,1.851,0,0,0,1.865,1.749,1.748,1.748,0,0,0,1.749-1.749,26.23,26.23,0,1,1,26.23,26.23,23.913,23.913,0,0,1-12.152-3.5h1.66a1.749,1.749,0,1,0,0-3.5H12.36c-1.423.2-1.948,1.157-1.7,2.172l1.749,7.111a1.749,1.749,0,0,0,3.395-.847l-.551-2.321a27.361,27.361,0,0,0,14.592,4.493A29.844,29.844,0,1,0,29.847,0Z",
    transform: "translate(-0.003)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.5f444265e813d11e80323119cc29d69e.svg";
export { ForwardRef as ReactComponent };